import { LINKEDJSON } from "./constants/specialContentTypes";

const getSequenceNumbersList = ({ page, ...restData }) => ({
  method: "GET",
  url: "/sequence_numbers",
  data: { ...restData, page: page + 1 },
});

const addSeqNum = (data) => ({
  method: "POST",
  url: "/sequence_numbers",
  data,
  headers: { ...LINKEDJSON },
});

const updateSeqNum = ({ id, ...data }) => ({
  method: "PUT",
  url: `/sequence_numbers/${id}`,
  data,
  headers: { ...LINKEDJSON },
});

const deleteSeqNum = ({ id }) => ({
  method: "DELETE",
  url: `/sequence_numbers/${id}`,
});

const createSequenceNumber = (data) => ({
  method: "GET",
  url: `/create_sequencenumber`,
  data,
});

export const sequenceNumbersApi = {
  getSequenceNumbersList,
  addSeqNum,
  updateSeqNum,
  deleteSeqNum,
  createSequenceNumber,
};
